/**
 * Single source of truth for focus-visible treatment. Button/Badge/
 * FilterChip interpolate these into their cva bases; bespoke raw
 * interactive elements (swatches, row targets, tab rails — see the
 * keep-raw criteria in .claude/rules) compose them via cn().
 */

/** Standard ring with page-background offset — default for islands. */
export const focusRing =
  "outline-none focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:ring-offset-2 focus-visible:ring-offset-background";

/** No offset — for dense rows, table cells, and flush list items. */
export const focusRingTight =
  "outline-none focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:ring-offset-0";

/**
 * Flow-canonical surfaces — accent ring offset against the fc canvas.
 * Only valid inside a [data-layout="flow-canonical"] / .fc-root subtree.
 */
export const focusRingFc =
  "outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--fc-accent)]/35 focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--fc-chat-bg)]";

/** Destructive actions. */
export const focusRingDestructive =
  "outline-none focus-visible:ring-2 focus-visible:ring-destructive/40 focus-visible:ring-offset-2 focus-visible:ring-offset-background";
